import { Modal } from 'bootstrap';


export default function initLanguage(){
	const script = document.createElement('script');
	script.type = 'text/javascript';
	script.src = "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
	document.head.appendChild(script);

	//watch <html> for language changes
	new MutationObserver((mutations) => {
		mutations.forEach((mutation) => {
			if(mutation.type === 'attributes' && mutation.attributeName === 'lang'){
				var langLabelEl = document.querySelector('.language-chooser-launcher.desktop');
				if(langLabelEl){
					if(document.documentElement.lang === "auto"){
						langLabelEl.textContent = "EN";
					}else{
						langLabelEl.textContent = document.documentElement.lang;
					}
				}
				langLabelEl = document.querySelector('.language-chooser-launcher.mobile-lang-chooser span.lang');
				if(langLabelEl){
					if(document.documentElement.lang === "auto"){
						langLabelEl.textContent = "EN";
					}else{
						langLabelEl.textContent = document.documentElement.lang;
					}
				}
				setActiveLangButton();
			}
		});
	}).observe(document.documentElement, { attributes: true });

	//watch for addition of div.skiptranslate to adjust header height
	new MutationObserver((mutations) => {
		mutations.forEach((mutation) => {
			if(mutation.type === 'childList' && mutation.addedNodes.length > 0){
				mutation.addedNodes.forEach((node) => {
					if(node.classList && node.classList.contains('skiptranslate')){
						// check if node display is none
						// console.log(window.getComputedStyle(node).display );
						if (window.getComputedStyle(node).display !== 'none') {
							// console.log('skiptranslate added');
						} else {
							// console.log('skiptranslate removed');
						}


						/*var header = document.querySelector('.header');
						if(header){
							var headerContent = header.querySelector('.header__content');
							if(headerContent){
								var navHeight = headerContent.getBoundingClientRect().height;
								if(navHeight > 140){
									header.classList.remove('header-responsive');
								}else{
									header.classList.add('header-responsive');
								}
							}
						}*/
					}
				});
			}
		});
	}).observe(document.body, { childList: true });




	var setActiveLangButton = function(){
		var langBtns = document.querySelectorAll('#language-modal .language-option');
		if(langBtns){
			langBtns.forEach(el => {
				if(el.getAttribute('data-code') === document.documentElement.lang){
					el.classList.add('btn-primary');
					el.classList.remove('btn-purple-light');
				}else{
					el.classList.remove('btn-primary');
					el.classList.add('btn-purple-light');
				}
			});
		}
	}
	setActiveLangButton();

	var changeLang = function(lang){
		if(lang === 'en-US'){
			//they choose english. clear the googtrans cookie and reload the page
			document.cookie = "googtrans=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
			window.location.reload();
		}else{
			var selectElement = document.querySelector('#google_translate_element select');
			selectElement.value = lang;
			selectElement.dispatchEvent(new Event('change'));
		}
		if(window.languageModal){
			window.languageModal.hide();
		}
	}

	document.querySelectorAll('.language-option').forEach(el => {
		el.addEventListener('click', function(e){
			e.preventDefault();
			var lang = this.getAttribute('data-code');
			changeLang(lang);
		});
	});

	//bind the submit button (mobile)
	document.querySelectorAll('#language-modal .options-select .btn').forEach(el => {
		el.addEventListener('click', function(e){
			var lang = document.querySelector('.language-select').value;
			changeLang(lang);
		});
	});

	//mobile select changes value trigger language change
	document.querySelector('.language-select').addEventListener('change', function(e){
		var lang = this.value;
		changeLang(lang);
	});


	const googtransCookie = document.cookie.split(';').filter(item => item.trim().startsWith('googtrans=')).map(item => item.split('=')[1])[0];
	if(googtransCookie && googtransCookie !== 'undefined' && googtransCookie !== 'null'){
		//google translate is already set. let it do its thing
		return;
	}else{
		//check if browser language is not english
		var langBrowser = navigator.language || navigator.userLanguage;
		var currentBLang = langBrowser?.split('-')[0];
		if (currentBLang != "en" && currentBLang != "en-US"){
			setTimeout(function() {
				var selectElement = document.querySelector('#google_translate_element select');
				selectElement.value = currentBLang;
				selectElement.dispatchEvent(new Event('change'));
				// mefaUpdateLanguageLabel();
			}, 1000);
		}
	}

}


window.googleTranslateElementInit = function(){
	window.googleTranslator = new google.translate.TranslateElement({
		pageLanguage: 'en',
		// includedLanguages: 'en,es,de,ru',
	}, 'google_translate_element');
}
